<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
    name: "App"
};
</script>

<style> 
html,
body {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
  
}
.demo-detail{
  color:#303133;
  font-size: 14px;
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
 
    widows: 100%;
    height: 100%;
   
}
.line1 {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	width: 100%;
}
.line1:hover{
text-overflow:inherit;
overflow:visible;
z-index: 2;

}
.button-two>.el-button--text{
  overflow: hidden;
  width: 100%;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -moz-box;
  -moz-line-clamp: 2;
  -moz-box-orient: vertical;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;    
}
/* 解决element-ui的table表格控件表头与内容列不对齐问题 */
.el-table th.gutter{
    display: table-cell!important;
  }
.el-input,.el-select{
  width: 215px;
}

</style>
